// src/components/common/Panel.jsx
import React from "react";

/**
 * 通用面板容器
 * 接受 children 和自訂 className
 */
export default function Panel({ children, className = "", ...props }) {
  return (
    <div className="relative flex">
      {/* 絕對定位，從父容器 top 撐到 bottom */}
      <div
        className="
          absolute inset-y-0 left-0   
          w-[1px] hidden lg:flex   
          bg-gradient-to-b         
            from-[#66E6F9]
            to-[#EC5EB7]
        "
      />
      <div
        className="
          min-w-[12px] h-[148px] hidden lg:flex my-auto rounded-l-[24px]  rounded-r-[4px]
          bg-gradient-to-b from-[#66E6F9] to-[#EC5EB7]
          opacity-[0]
        "
      />
      {/* 右邊區塊，補上 left margin，避免被線蓋住 */}
      <div
        className={`
          relative flex items-center justify-center p-6 px-[26px] w-full max-w-[99%] h-fit backdrop-blur-[40px]
          bg-gradient-to-br from-white/15 via-white/10 to-white/0 rounded-[16px]
          border border-white
          ${className}
        `}
        {...props}
      >
        <div className="gradient-border [--gb-start:#66E6F9] [--gb-end:#EC5EB7] w-[18px] h-[18px] rounded-full !absolute top-[6px] left-[6px]"></div>
        {children}
      </div>
    </div>
  );
}
